<template>
	<nav v-if="totalPages > 1" aria-label="Product pagination">
		<ul class="pagination pagination-sm mb-0">
			<li class="page-item" :class="{ disabled: currentPage <= 1 }">
				<button class="page-link" @click="$emit('page', currentPage - 1)">&lsaquo;</button>
			</li>
			<li
				v-for="p in visiblePages"
				:key="p"
				class="page-item"
				:class="{ active: p === currentPage }"
			>
				<button class="page-link" @click="$emit('page', p)">
					{{ p }}
				</button>
			</li>
			<li class="page-item" :class="{ disabled: currentPage >= totalPages }">
				<button class="page-link" @click="$emit('page', currentPage + 1)">&rsaquo;</button>
			</li>
		</ul>
	</nav>
</template>

<script>
import { computed } from 'vue';

export default {
	name: 'CloseoutPagination',
	props: {
		currentPage: { type: Number, required: true },
		totalPages: { type: Number, required: true },
	},
	emits: ['page'],
	setup(props) {
		const visiblePages = computed(() => {
			const pages = [];
			const total = props.totalPages;
			const current = props.currentPage;
			const maxVisible = 6;

			let start = Math.max(1, current - Math.floor(maxVisible / 2));
			let end = Math.min(total, start + maxVisible - 1);
			if (end - start < maxVisible - 1) {
				start = Math.max(1, end - maxVisible + 1);
			}

			for (let i = start; i <= end; i++) {
				pages.push(i);
			}
			return pages;
		});

		return { visiblePages };
	},
};
</script>
